import releaseMeta from "./release.meta.json";
import bundles from "./bundles.json";
import features from "./features.json";

export const navigationOverhaulRelease = {
  meta: releaseMeta,
  bundles,
  features,
};

export default navigationOverhaulRelease;
